import { message } from '@svg/antd';
import { sunvegaAPI } from 'utils';
import type { MessageProps } from 'utils/sunvegaAPI';

export default function CommonMessage(props: MessageProps) {
  if (sunvegaAPI.isInNewClouddesign()) {
    sunvegaAPI.openMessage(props)
  } else {
    message.open(props)
  }
}